export default __webpack_public_path__ + "static/media/vertical6.0c2fbb3e.JPG";